import * as React from 'react';
import { ArticleHeading4, ArticleParagraph3 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface ICounter {
  label: string;
  text: string;
}

interface ICountersProps {
  counters: ICounter[];
}

export const Counters = ({ counters }: ICountersProps) => {
  return (
    <div className={styles['counters']}>
      {counters.map(({ label, text }) => (
        <div key={label} className={styles['counters-item']}>
          <ArticleParagraph3 color="text-secondary-default">{label}</ArticleParagraph3>
          <ArticleHeading4>{text}</ArticleHeading4>
        </div>
      ))}
    </div>
  );
};
